module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// /home/markush/Projects/fieldsale-wingman-client/src/fonts/glyphicons-halflings-regular.woff
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.woff
// module chunks = styles